export var ACCORDION_REVEAL_ANIMATION_DURATION = 500;